import { render, staticRenderFns } from "./CourseForum.vue?vue&type=template&id=0da5fab9&scoped=true&"
import script from "./CourseForum.vue?vue&type=script&lang=js&"
export * from "./CourseForum.vue?vue&type=script&lang=js&"
import style0 from "./CourseForum.vue?vue&type=style&index=0&id=0da5fab9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5fab9",
  null
  
)

export default component.exports